<template>
  <div id="app" class="px-3 lg:px-0">
    <div class="relative flex flex-col-reverse lg:flex-row mx-auto lg:w-[1200px] pb-24">
      <div class="py-8 lg:pr-8 w-full lg:w-[60%]" style="max-width: 100%">
        <img v-if="mainImage && mainImage.url" class="sf-desktop-image" :src="mainImage.url" alt="" />

        <dimensions :step="getStep(1)" :totalSteps="totalSteps" :category="174"></dimensions>
        <box-color :step="getStep(2)" :totalSteps="totalSteps" :category="208"></box-color>
        <material-color :step="getStep(3)" :totalSteps="totalSteps" :category="209"></material-color>
        <volant :step="getStep(4)" :totalSteps="totalSteps" :category="216"></volant>
        <attachment :step="getStep(5)" :totalSteps="totalSteps" :category="210"></attachment>
        <drive :step="getStep(6)" :totalSteps="totalSteps" :category="211"></drive>
        <remote :step="getStep(7)" :totalSteps="totalSteps" :category="212"></remote>
        <side :step="getStep(8)" :totalSteps="totalSteps" :category="213"></side>
        <extras :step="getStep(9)" :totalSteps="totalSteps" :category="214"></extras>
        <lighting :step="getStep(10)" :totalSteps="totalSteps" :category="215"></lighting>

        <button
          class="block lg:hidden w-full bg-yellow-400 font-bold rounded-sm px-8 py-2 mt-4"
          :class="{
            'bg-green-400': buttonSuccess,
            'bg-gray-300 sf-button-loading': buttonLoading,
            'bg-gray-400 cursor-not-allowed': buttonDisabled,
          }"
          @click="addToBasket"
          :disabled="buttonDisabled"
        >
          <span v-if="!buttonSuccess && !buttonLoading">In den Warenkorb</span>
          <span v-if="buttonLoading">Wird hinzugefügt</span>
          <span v-if="buttonSuccess">Produkt ist im Warenkorb</span>
        </button>
      </div>

      <fixed-header :threshold="210">
        <div class="navbar w-full lg:w-[40%]">
          <div class="py-8 lg:pr-8 w-full self-start">
            <img class="sf-mobile-image" v-if="mainImage && mainImage.urlMiddle" :src="mainImage.urlMiddle" alt="" />

            <h1 class="text-3xl text-gray-700 font-bold">Markisenkonfigurator</h1>
            <h2 class="text-xl text-gray-600">Brustor {{ setItemTexts.name1 }}</h2>
            <p v-if="false" class="text-gray-700 mt-4" v-html="setItemTexts.description"></p>

            <availability :availability="9"></availability>

            <div class="mt-8">
              <p class="text-3xl" style="font-weight: 500">{{ totalPrice | formatPrice }} EUR*</p>
              <div class="text-sm text-gray-500">
                <p>
                  * inkl. ges. MwSt. inkl. <a class="font-bold hover:text-yellow-400" href="/webshop/zahlung-versand/">Versandkosten</a>
                </p>
              </div>

              <button
                class="w-full bg-yellow-400 font-bold rounded-sm px-8 py-2 mt-4"
                :class="{
                  'bg-green-400': buttonSuccess,
                  'bg-gray-300 sf-button-loading': buttonLoading,
                  'bg-gray-400 cursor-not-allowed': buttonDisabled,
                }"
                @click="addToBasket"
                :disabled="buttonDisabled"
              >
                <span v-if="!buttonSuccess && !buttonLoading">In den Warenkorb</span>
                <span v-if="buttonLoading">Wird hinzugefügt</span>
                <span v-if="buttonSuccess">Produkt ist im Warenkorb</span>
              </button>

              <div class="mt-6 pt-6 border-t-4 border-t-gray-200">
                <p class="flex text-xl font-bold text-gray-700">
                  <sf-icon size="lg" :icon="['far', 'clock']" class="text-yellow-400" /><span class="ml-2">Später weitermachen?</span>
                </p>
                <p class="text-gray-700 mt-1">
                  Sie können sich diese Seite als Lesezeichen speichern oder die URL kopieren und später mit ihrer Konfiguration, an
                  aktueller Stelle, weitermachen. Ihre Auswahl und Eingaben bleiben in diesem Fall erhalten.
                </p>
                <button
                  class="w-full bg-gray-200 text-gray-700 font-bold rounded-sm px-8 py-2 mt-4"
                  :class="{ 'bg-green-400': textCopied }"
                  @click="copyUrlToClipboard"
                >
                  <span v-if="!textCopied">Link kopieren</span>
                  <span v-if="textCopied">Link wurde kopiert</span>
                </button>
              </div>

              <div class="mt-6 pt-6 border-t-4 border-t-gray-200">
                <p class="flex text-xl font-bold text-gray-700">
                  <sf-icon size="lg" :icon="['far', 'question-circle']" class="text-yellow-400" /><span class="ml-2"
                    >Sie haben Fragen?</span
                  >
                </p>
                <p class="text-gray-700 mt-1">
                  Unser kompetenes Team steht Ihnen bei Fragen gerne zur Verfügung. Sie erreichen uns telefonisch Montags bis Freitags von 8
                  bis 18 Uhr, sowie Samstags von 10:00 bis 14:00 Uhr unter:
                  <a class="font-bold hover:text-yellow-400" href="tel:025239989019">02523-9989019</a><br /><br />
                  Alternativ können Sie uns auch per E-Mail kontaktieren:
                  <a class="font-bold hover:text-yellow-400" href="mailto:kontakt@schattenfix.de">kontakt@schattenfix.de</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </fixed-header>

      <vue-easy-lightbox moveDisabled :visible="visible" :imgs="imgs" :index="index" @hide="$store.commit('lightbox/setVisibility', false)">
      </vue-easy-lightbox>

      <ssg-confirm-modal :title="this.modalTitle" :visible="showModal" :content="modalBody" @close="closeModal">
      </ssg-confirm-modal>

      <div style="display: none" class="w-3/5 w-2/5 mr-4">
        This is just to make sure that the classes are included in the build (for category content)
      </div>
    </div>

    <!-- Back to top button -->
    <div class="lg:hidden fixed bottom-0 right-0 mr-4 mb-4">
      <button class="bg-yellow-400 font-bold rounded-sm px-4 py-2" @click="scrollToTop">
        <span>Nach oben</span>
      </button>
    </div>
  </div>
</template>

<script>
import Attachment from "./sections/Attachment.vue";
import MaterialColor from "./sections/MaterialColor.vue";
import BoxColor from "./sections/BoxColor.vue";
import Dimensions from "./sections/Dimensions.vue";
import Drive from "./sections/Drive.vue";
import Lighting from "./sections/Lighting.vue";
import Remote from "./sections/Remote.vue";
import Volant from "./sections/Volant.vue";
import Side from "./sections/Side.vue";
import Extras from "./sections/Extras.vue";

import FixedHeader from "vue-fixed-header";
import axios from "axios";
import { mapState } from "vuex";
import { getVariationsByAttributeType } from "./sections/plentyHelpers";
import Availability from "./components/Availability.vue";

export default {
  components: {
    FixedHeader,
    Dimensions,
    BoxColor,
    MaterialColor,
    Attachment,
    Lighting,
    Drive,
    Volant,
    Remote,
    Side,
    Extras,
    Availability,
  },

  data() {
    return {
      urlParsed: false,
      textCopied: false,
      setItemTexts: {},
      mainImage: {},
      setVariationId: null,
      buttonLoading: false,
      buttonSuccess: false,
    };
  },

  async created() {
    await this.fetchSetData();

    this.$nextTick(() => {
      this.setStateBasedOnQueryParameters();

      requestAnimationFrame((requestAnimationFrame) => {
        this.urlParsed = true;
      });
    });

    this.watchScroll();
  },

  computed: {
    ...mapState("lightbox/", {
      imgs: (state) => state.images,
      visible: (state) => state.visible,
      index: (state) => state.index,
    }),

    ...mapState("modal/", {
      modalTitle: (state) => state.title,
      modalBody: (state) => state.body,
      showModal: (state) => state.open
    }),

    modalHeaderOptions() {
      return { title: this.modalTitle };
    },

    hasVolant() {
      return this.$store.state.volant.options.length > 0;
    },

    hasRemote() {
      return this.$store.state.drive?.selection?.id === 4232; // Check if Motor IO is selected
    },

    hasLightingOption() {
      let isNotKurbel = this.$store.state.drive?.selection?.id === 4232 || this.$store.state.drive?.selection?.id === 4231; // Not Kurbel option
      let isNotB50 = this.$store.state.set.setItem.id != 950; // B50 has no lighting option

      return isNotKurbel && isNotB50;
    },

    totalSteps() {
      let steps = 8;

      if (this.hasVolant) steps += 1;
      if (this.hasLightingOption) steps += 1;
      if (this.hasRemote) steps += 1;

      return steps;
    },

    urlSummary() {
      return {
        width: this.$store.state.dimensions.width,
        dimensions: this.$store.state.dimensions.selection?.id,
        boxColor: this.$store.state.boxColor.selection?.id,
        materialColor: this.$store.state.materialColor.selection?.id,
        attachement: this.$store.state.attachement.selection?.id,
        drive: this.$store.state.drive.selection?.id,
        lighting: this.$store.state.lighting.selection?.id,
        remote: this.$store.state.remote.selection?.id,
        volant: this.$store.state.volant.selection?.id,
        side: this.$store.state.side.selection?.id,
        extras: this.$store.state.extras.selection.map((selection) => selection.id).join(","),
      };
    },

    totalPrice() {
      // Calculate total price based on every selection for every store module
      const price = [
        this.$store.state.dimensions.selection?.variationSalesPrices?.[0]?.price,
        this.$store.state.boxColor.selection?.variationSalesPrices?.[0]?.price,
        this.$store.state.materialColor.selection?.variationSalesPrices?.[0]?.price,
        this.$store.state.attachement.selection?.variationSalesPrices?.[0]?.price,
        this.$store.state.drive.selection?.variationSalesPrices?.[0]?.price,
        this.$store.state.remote.selection?.variationSalesPrices?.[0]?.price,
        this.$store.state.volant.selection?.variationSalesPrices?.[0]?.price,
        this.$store.state.side.selection?.variationSalesPrices?.[0]?.price,
        this.$store.state.lighting.selection.map((selection) => selection?.variationSalesPrices?.[0]?.price).reduce((a, b) => a + b, 0),
        this.$store.state.extras.selection.map((selection) => selection?.variationSalesPrices?.[0]?.price).reduce((a, b) => a + b, 0),
      ];

      // Filter out all empty values
      const filteredPrice = price.filter((value) => value !== undefined);

      return filteredPrice.reduce((a, b) => a + b, 0);
    },

    buttonDisabled() {
      if (!this.$store.state.dimensions?.selection?.id) return true;
    },
  },

  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },

    watchScroll() {
      if (window.clientWidth > 1024) return;

      let body = document.querySelector("body");
      let footer = document.querySelector(".footer");
      if (!body || !footer) return;

      document.addEventListener("scroll", function (e) {
        let header = document.querySelector(".vue-fixed-header");
        let maxScroll = body.clientHeight - footer.clientHeight - window.innerHeight;

        if (header && scrollY > maxScroll) {
          header.classList.remove("vue-fixed-header--isFixed");
          header.classList.add("header-bottom-reached");
        } else if (scrollY > 210) {
          header.classList.remove("header-bottom-reached");
          header.classList.add("vue-fixed-header--isFixed");
        }
      });
    },

    getStep(step) {
      if (!this.hasVolant && step > 4) step -= 1;
      if ((!this.hasVolant && !this.hasRemote && step > 6) || (this.hasVolant && !this.hasRemote && step > 7)) step -= 1;

      return step;
    },

    async fetchSetData() {
      // Regex to find value of queryparameter 'setId' in url
      const setId = window.location.href.match(/setId=([^&]*)/)[1] || 918;

      let setData = await axios.get(`/markisen-konfigurator/set/?setId=${setId}&pluginSetPreview=${this.$setPreview}`);
      setData = setData.data.set;
      this.$store.commit("set/setSetItem", setData.item);

      this.setVariationId = setData.item.mainVariationId;
      this.setItemTexts = setData.item.texts[0];

      let dimensions = getVariationsByAttributeType(setData, "Ausfall");
      let volantOptions = getVariationsByAttributeType(setData, "Volantfarbe");
      this.fetchMainImages();

      this.$store.commit("dimensions/setDimensionVariations", dimensions);
      this.$store.commit("boxColor/setOptions", getVariationsByAttributeType(setData, "Gestellfarbe"));
      this.$store.commit("materialColor/setOptions", getVariationsByAttributeType(setData, "Tuchfarbe"));
      this.$store.commit("volant/setOptions", volantOptions);
      this.$store.commit("attachement/setOptions", getVariationsByAttributeType(setData, "Befestigung"));
      this.$store.commit("drive/setOptions", getVariationsByAttributeType(setData, "Antrieb"));
      this.$store.commit("remote/setOptions", getVariationsByAttributeType(setData, "Modell"));
      this.$store.commit("side/setOptions", getVariationsByAttributeType(setData, "Bedienseite"));
      this.$store.commit("extras/setOptions", getVariationsByAttributeType(setData, "Ausgewählt"));
      this.$store.commit("lighting/setOptions", getVariationsByAttributeType(setData, "Position"));

      let includesVolant = volantOptions.length > 0;
      this.fetchOptionImages(includesVolant);

      return setData;
    },

    fetchMainImages() {
      axios
        .get(`/markisen-konfigurator/images/?variationId=${this.setVariationId}}`)
        .then((response) => {
          this.mainImage = response.data.images.sort((a, b) => a.position - b.position)[0];
          let dimensionImage = response.data.images.find((image) => image?.url.includes("TABELLE-"));
          if (dimensionImage) this.$store.commit("set/setDimensionImage", dimensionImage?.url);
        });
    },

    fetchOptionImages(includesVolant) {
      this.$store.dispatch("boxColor/fetchImages", this.$setPreview);
      this.$store.dispatch("materialColor/fetchImages", this.$setPreview);
      if (includesVolant) this.$store.dispatch("volant/fetchImages", this.$setPreview);
    },

    copyUrlToClipboard() {
      const url = window.location.href;
      const textField = document.createElement("textarea");
      textField.style.position = "absolute";
      textField.style.opacity = 0;
      textField.innerText = url;
      document.body.appendChild(textField);
      textField.select();
      navigator.clipboard.writeText(textField.value);
      textField.remove();

      this.textCopied = true;
      setTimeout(() => {
        this.textCopied = false;
      }, 3000);
    },

    closeModal() {
      this.$store.commit("modal/closeModal")
    },

    updateQueryParameters() {
      this.$router.replace({
        query: {
          ...this.urlSummary,
        },
      });
    },

    setStateBasedOnQueryParameters() {
      // Go through all queryparameters and set selections and values in store
      let query = this.$route.query;
      let keys = [
        "width",
        "dimensions",
        "boxColor",
        "materialColor",
        "attachement",
        "drive",
        "lighting",
        "remote",
        "volant",
        "side",
        "extras",
      ];

      for (const key of keys) {
        if (Object.hasOwnProperty.call(query, key)) {
          const id = query[key];

          if (key === "width") {
            this.$store.commit("dimensions/setWidth", id);
          } else if (key === "extras") {
            // Id is potentially string of multiple ids in this case
            let ids = id.trim().split(",");

            // Only include options which ids are in the ids array
            ids = ids.map((id) => Number(id));
            let selections = this.$store.state.extras.options.filter((option) => ids.includes(option.id));

            // Make sure all components are created, so that the default selection happens before this and not after
            this.$nextTick(() => {
              this.$store.commit(`${key}/setSelection`, selections);
            });
          } else {
            if (!this.$store.state[key]) continue;

            this.$nextTick(() => {
              let option = this.$store.state[key].options.find((option) => option.id == id);
              this.$store.commit(`${key}/setSelection`, option);
            });
          }
        } else {
          // If no value is set in the url, use default selection
          if (!this.$store.state[key]?.defaultSelection) continue;

          this.$nextTick(() => {
            // TODO: Maybe switch default selection to variationNumber instead of ID
            let option = this.$store.state[key].options.find((option) => option.id == this.$store.state[key].defaultSelection);
            if (option) this.$store.commit(`${key}/setSelection`, option);
          });

          continue;
        }
      }
    },

    flashButtonSuccess() {
      this.buttonSuccess = true;

      setTimeout(() => {
        this.buttonSuccess = false;
      }, 5000);
    },

    addToBasket() {
      if (this.buttonDisabled) return;
      this.buttonLoading = true;

      const basketObject = this.createBasketObject();

      // Debugging
      console.log({
        remotePrice: this.$store.state.remote.selection?.variationSalesPrices?.[0]?.price,
        remoteSelection: this.$store.state.remote.selection,
        basketObject,
      });

      if (window.location.host === "localhost:8080") return;

      window.vueApp.$store.dispatch("addBasketItem", basketObject).then(
        (response) => {
          this.buttonLoading = false;
          this.flashButtonSuccess();
        },
        (error) => {
          if (error.data) console.log({ error: error.data });
        }
      );
    },

    createBasketObject() {
      let basketObject = {
        variationId: this.setVariationId,
        quantity: 1,
        basketItemOrderParams: [],
        totalOrderParamsMarkup: 0,
        setComponents: [],
        template: "Ceres::Basket.Basket",
        templateType: "item",
      };

      for (const key in this.$store.state) {
        if (!Object.hasOwnProperty.call(this.$store.state, key)) continue;
        const module = this.$store.state[key];
        const modulesWithOptionalItems = ["extras", "volant", "lighting", "remote"];
        if (!module.selection || !module.options[0]) continue;

        if (modulesWithOptionalItems.includes(key)) basketObject = this.handleOptionalItems(basketObject, module);
        else if (key === "dimensions") basketObject = this.addDimensions(basketObject, module);
        else basketObject = this.addSelection(basketObject, module);
      }

      return basketObject;
    },

    addDimensions(basketObject, module) {
      let variationId = module.selection.id;
      if (!variationId) return basketObject;

      // If is dimension module
      // add orderProperty width to basketObject
      basketObject.setComponents.push({
        variationId,
        quantity: 1,
        basketItemOrderParams: [
          {
            propertyId: 107, // Eigenschaft ID:107 - Merkmal ID:5
            type: "int",
            name: "Individuelle Breite (cm)",
            value: module.width,
          },
        ],
        totalOrderParamsMarkup: 0,
      });

      console.log("Individuelle Breite", basketObject);
      

      return basketObject;
    },

    addSelection(basketObject, module) {
      let variationId = module.selection.id;
      if (!variationId) return basketObject;

      basketObject.setComponents.push({
        variationId,
        quantity: 1,
        basketItemOrderParams: [],
        totalOrderParamsMarkup: [],
      });

      return basketObject;
    },

    handleOptionalItems(basketObject, module) {
      let alreadyAddedVariationForItem = {};

      for (const option of module.options) {
        // Check if option is selected (single selection)
        let selectionId = module.selection.id;

        // Account for multiple selections (e.g. extras)
        if (!selectionId && module.selection[0]) {
          // Check if the option is one of the selected ones
          selectionId = module.selection.find((selection) => selection.id == option.id)?.id;
        }

        // Make sure not to add multiple variations of the same item
        if (alreadyAddedVariationForItem[option.itemId]) continue;

        // If is not selected push kaVariation (keine Auswahl) to components, since one variation from each item must always be selected
        if (!selectionId) {
          // Check if another variation from the same item is selected
          if (module.selection.find((selection) => selection.itemId == option.itemId && selection.id != option.id)) {
            console.log("ANOTHER VARIATION SELECTED", option.itemId);
            continue;
          }

          // Get KA (Keine Auswahl) variation for optional products, since plenty does not allow no variation to be selected for an item contained in a set
          let kaVariation = this.getKaVariation(module, option);

          // Avoid duplicate entries
          if (basketObject.setComponents.some((component) => component.variationId === kaVariation.id)) continue;

          basketObject.setComponents.push({
            variationId: kaVariation.id,
            quantity: 1,
            basketItemOrderParams: [],
            totalOrderParamsMarkup: [],
          });

          alreadyAddedVariationForItem[option.itemId] = true;
          continue;
        }

        basketObject.setComponents.push({
          variationId: selectionId,
          quantity: 1,
          basketItemOrderParams: [],
          totalOrderParamsMarkup: [],
        });

        alreadyAddedVariationForItem[option.itemId] = true;
      }

      return basketObject;
    },

    getKaVariation(module, variation) {
      return module.options.find((option) => option.number.includes("-KA") && option.itemId == variation.itemId);
    },
  },

  watch: {
    urlSummary() {
      if (this.urlParsed) this.updateQueryParameters();
    },
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.navbar.vue-fixed-header--isFixed {
  position: relative !important;

  @media only screen and (min-width: 1024px) {
    position: fixed !important;
    left: calc(50vw + 112px);
    top: 0 !important;
    width: calc(1200px / 100 * 40);
    z-index: 100;
    padding-top: 0px;
  }
}

.header-bottom-reached {
  align-self: flex-end;
}

#vm2__cover_wrapper_info-modal,
#vm2__cover_wrapper_add-to-basket-modal {
  z-index: 20000;
}

.vm2_body {
  padding: 15px 0;
}

.vm2__header {
  padding-bottom: 7px;
}

.vm2_modal-content {
  max-height: 100%;

  @media only screen and (max-width: 1024px) {
    overflow: scroll;
  }
}

.vm2_body {
  @media only screen and (min-width: 1024px) {
    height: 85vh;
    overflow: scroll;
  }
}

.vm2_settings {
  max-width: none !important;

  @media only screen and (min-width: 1024px) {
    margin-left: 15%;
    margin-right: 15%;
  }
}

.sf-button-loading {
  background-color: #222;
  animation-name: color;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}

@keyframes color {
  0% {
    background-color: #fcd34d;
  }
  50% {
    background-color: #fff2c7;
  }
  100% {
    background-color: #fcd34d;
  }
}

.sf-desktop-image {
  display: none;
}

.sf-mobile-image {
  display: block;
  margin-bottom: 30px;
}

@media only screen and (min-width: 768px) {
  .sf-desktop-image {
    display: block;
  }

  .sf-mobile-image {
    display: none;
  }
}

.widget-availability {
  > span {
    @media only screen and (max-width: 768px) {
      white-space: normal;
      line-height: 1.5;
      text-align: left;
    }
  }
}
</style>
